export const API_HOST = import.meta.env.VITE_APP_API_HOST;
export const SOCKET_URL = import.meta.env.VITE_APP_SOCKET_URL;
export const DATA_ENCRYPT_KEY = import.meta.env.VITE_APP_DATA_ENCRYPT_KEY;
export const ALGO_SERVER = import.meta.env.VITE_APP_ALGO_SERVER;
export const ALGO_INDEXER = import.meta.env.VITE_APP_ALGO_INDEXER;
export const INDEXER_API = import.meta.env.VITE_APP_INDEXER_API;
export const ALGOD_TOKEN = import.meta.env.VITE_APP_ALGOD_TOKEN;
export const DISPENSER_LINK = import.meta.env.VITE_APP_DISPENSER_LINK;
export const GLOWL_DECIMAL = 4;
export const EXCHANGE_NAME = "Oasis Pro Market";
export const ORDER_BOOK_SIZE = 50;
export const PRICE_SCALE_VALUE = 4;
export const MARKET_TRADES_SIZE = 50;
export const WITHDRAW_FEE = 0.001 * 10 ** 6;
export const APP_CLOSEOUT_FEE = 0.002 * 10 ** 6;
export const ORDER_BOOK_LENGTH = 16;
export const DAY_ORDER_EXPIRY_TIME = "16:30";
export const TZ = 'America/New_York';
export const DAY_EXPIRE = '4:30 pm';
export const ESTIMATE_GAS = 21000;
export const MESSAGES = {
    PAIR_ADDED_TO_FAVOURITE: 'Pair added to favorites!',
    PAIR_REMOVED_TO_FAVOURITE: 'Pair removed from favorites!',
};
export const SOCKET = {
    JOIN_ROOM: 'joinRoom',
    BUY_ORDERBOOK: "_BUY_ORDERBOOK",
    SELL_ORDERBOOK: "_SELL_ORDERBOOK",
    CANCEL_ORDER: "_CANCEL_ORDER_BOOK",
    TRADE_BOOK: "_TRADE_ORDERBOOK",
    SPEEDBUMP_TRADE_BOOK: "_SPEEDBUMP_TRADE_ORDERBOOK",
    LAST_TRADE_PRICE: "LAST_TRADE_PRICE",
    CHANGE24: "CHANGE24",
    OPEN_ORDERS: "_ACTIVE_ORDERS",
    USER_CANCEL_ORDER: "_CANCEL_ORDER",
    USER_TRADE: "_TRADE_ORDERS",
    SPEEDBUMP_USER_TRADE: "_SPEEDBUMP_TRADE_ORDERS",
    USER_NOTIFICATION: "USER_NOTIFICATION",
    USER_WALLET_BALANCE: "USER_WALLET_BALANCE",
    REPORT: "pnl_report_"
}

/**
 * Server socket rooms/events use underscores (e.g. TTRX_TARCUSDC); REST may expose
 * pair_key with "/" (e.g. TTRX/TARCUSDC). Listen and emit using this prefix only.
 */
export function socketPairTopicPrefix(pairKey) {
    if (pairKey == null || typeof pairKey !== 'string') return '';
    return String(pairKey).trim().replace(/\//g, '_').toUpperCase();
}
